/* eslint-disable */
import React from 'react';
import 'contents/assets/scss/page/community.scss';
import ImageI from 'contents/assets/img/Image1.png';
import ImageII from 'contents/assets/img/Image2.png';
import ImageIII from 'contents/assets/img/Image3.png';
import ImageIV from 'contents/assets/img/Image4.png';
import ImageV from 'contents/assets/img/Image5.png';
import ImageVI from 'contents/assets/img/Image6.png';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
const Index = () => {
  return (
    <main className="com_container com_community p_community_index">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_1 ">커뮤니티 메인</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="detail_tit dot">공지사항</div>
            <table className="com_board_list">
              <colgroup>
                <col width="15%" />
                <col width="10%" />
                <col width="52%" />
                <col width="10%" />
                <col width="15%" />
              </colgroup>
              <thead>
                <tr>
                  <th>등록일</th>
                  <th>카테고리</th>
                  <th>내용</th>
                  <th>파일</th>
                  <th>등록자</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="td_date">
                    <span className="icon_new" />
                    2022,03,07
                  </td>
                  <td>학생</td>
                  <td className="td_left">안녕하세요. 공지사항입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>학생</td>
                  <td className="td_left">안녕하세요. 공지사항입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>학생</td>
                  <td className="td_left">안녕하세요. 공지사항입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>학생</td>
                  <td className="td_left">안녕하세요. 공지사항입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>학생</td>
                  <td className="td_left">안녕하세요. 공지사항입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>학생</td>
                  <td className="td_left">안녕하세요. 공지사항입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>학생</td>
                  <td className="td_left">안녕하세요. 공지사항입니다.</td>
                  <td>
                    <button className="btn_link point">다운로드</button>
                  </td>
                  <td>홍길동 103</td>
                </tr>
              </tbody>
            </table>
          </section>
          <section className="box">
            <div className="detail_tit dot">강의실 예약</div>
            <table className="com_board_list">
              <colgroup>
                <col width="20%" />
                <col width="20%" />
                <col width="auto" />
                <col width="15%" />
              </colgroup>
              <thead>
                <tr>
                  <th>등록일</th>
                  <th>예약일</th>
                  <th>내용</th>
                  <th>예약자</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>
                    2023, 02, 30
                    <br />
                    18 : 30 ~ 20 : 00
                  </td>
                  <td className="td_left">안녕하세요. 강의실예약입니다.</td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>
                    2023, 02, 30
                    <br />
                    18 : 30 ~ 20 : 00
                  </td>
                  <td className="td_left">안녕하세요. 강의실예약입니다.</td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>
                    2023, 02, 30
                    <br />
                    18 : 30 ~ 20 : 00
                  </td>
                  <td className="td_left">안녕하세요. 강의실예약입니다.</td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>
                    2023, 02, 30
                    <br />
                    18 : 30 ~ 20 : 00
                  </td>
                  <td className="td_left">안녕하세요. 강의실예약입니다.</td>
                  <td>홍길동 103</td>
                </tr>
                <tr>
                  <td className="td_date">2022,03,07</td>
                  <td>
                    2023, 02, 30
                    <br />
                    18 : 30 ~ 20 : 00
                  </td>
                  <td className="td_left">안녕하세요. 강의실예약입니다.</td>
                  <td>홍길동 103</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="box full">
            <div className="detail_tit dot">이지 포토</div>
            <div className="photo_container">
              <button className="btn icon_prev "></button>
              <div className="photo_box">
                <div className="com_info">
                  <p className="name">2023년 파이널 캠페인 시상식</p>

                  <p className="date">2022, 03, 07</p>
                  <div className="count">
                    <BtnLike/>
                  </div>
                </div>

                <div className="photos_list">
                  <div className="photo">
                    <img src={ImageI} alt="image-1" />
                  </div>
                  <div className="photo">
                    <img src={ImageII} alt="image-2" />
                  </div>
                  <div className="photo">
                    <img src={ImageIII} alt="image-3" />
                  </div>
                  <div className="photo">
                    <img src={ImageIV} alt="image-4" />
                  </div>
                  <div className="photo">
                    <img src={ImageV} alt="image-5" />
                  </div>
                  <div className="photo">
                    <img src={ImageVI} alt="image-6" />
                  </div>
                  <div className="photo">
                    <img src={ImageVI} alt="image-7" />
                  </div>
                  <div className="photo">
                    <img src={ImageVI} alt="image-8" />
                  </div>
                  <div className="photo">
                    <img src={ImageVI} alt="image-9" />
                  </div>
                  <div className="photo">
                    <img src={ImageVI} alt="image-10" />
                  </div>
                  <div className="photo">
                    <img src={ImageVI} alt="image-11" />
                  </div>
                  <div className="photo">
                    <img src={ImageVI} alt="image-12" />
                  </div>
                </div>
                <div className="photo_info">
                  <p className="txt">김등록210</p>

                  <div className="photo_stats">
                    <div className="comments">
                      <button type="button" className="btn_comments" onClick={() => {}}></button>
                      <p className="txt">24</p>
                    </div>
                    <div className="seen">
                      <button type="button" className="btn_seen" onClick={() => {}}></button>
                      <p>325</p>
                    </div>
                  </div>
                </div>
              </div>
              <button className="btn icon_next"></button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default Index;
